module.exports = __webpack_public_path__ + "static/freshman-2-ca8c27d007c30d99d1bde368e4cef652.jpg";